module.exports = __webpack_public_path__ + "img/green-bg-arrow-down.5275b6ba.svg";